// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

import indexvideo from '@/views/video';

//首页
import indexIndex from '@/views/index/index';
//首页 个人中心
import indexContent from '@/views/index/content';

/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 平台相关配置
import Platform from '@/views/system/Platform';
// 权限管理
import Permission from '@/views/system/Permission';
// 短信记录
import Message from '@/views/system/Message';
// 通知管理
import Notice from '@/views/system/Notice';
// 文档管理
import systemDocument from '@/views/system/Document';

/**
 * 专利管理
 */
// 专利检索
import patentSearch from '@/views/patent/search';
// 数据更新
import patentRefresh from '@/views/patent/refresh';
// 年费缴纳
import patentAnnual from '@/views/patent/annual';
// 监控列表
import patentMonitor from '@/views/patent/monitor';
// 检索任务
import patentTask from '@/views/patent/task';

// 控制台01
import console01 from '@/views/console/console01';

// 控制台01
import companyBusiness from '@/views/company/business';
// 展示面板(代理机构版)
import consoleAgency from '@/views/console/consoleAgency';
// 展示面板(园区版)
import consolePark from '@/views/console/consolePark';
// 展示面板(企业版)
import consoleBusiness from '@/views/console/consoleBusiness';
// 展示面板(高校版)
import consoleCollege from '@/views/console/consoleCollege';
// 展示面板(超级管理员版)
import consoleSuper from '@/views/console/consoleSuper';

// 商标
import markList from '@/views/mark/markList';
// 软著
import softList from '@/views/soft/softList';
// 专利
import patList from '@/views/pat/patList';

// 系统管理-专利管理(技术领域)
import systemTechnology from '@/views/system/technology';





// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [
        {
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, 
    {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        },
        children: [{
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Platform',
            name: '平台相关配置',
            component: Platform,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Message',
            name: '短信记录',
            component: Message,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Notice',
            name: '通知管理',
            component: Notice,
            meta: {
                requireAuth: true
            }
        },{
          path: '/system/Document',
          name: '文档管理',
          component: systemDocument,
          meta: {
              requireAuth: true
          }
        },{
            path: '/index/index',
            name: '首页',
            component: indexIndex,
            meta: {
                requireAuth: true
            }
        },{
            path: '/index/video',
            name: '视频上传',
            component: indexvideo,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/index/content',
            name: '个人中心',
            component: indexContent,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/patent/search',
            name: '专利检索',
            component: patentSearch,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/patent/refresh',
            name: '数据更新',
            component: patentRefresh,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/patent/annual',
            name: '年费缴纳',
            component: patentAnnual,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/patent/monitor',
            name: '监控大厅',
            component: patentMonitor,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/patent/task',
            name: '检索任务',
            component: patentTask,
            meta: {
                requireAuth: true
            }
        },
        {
          path: '/console/console01',
          name: '控制台',
          component: console01,
          iconCls: 'el-icon-tickets',
          meta: {
            requireAuth: true
          }
      },
      {
        path: '/company/business',
        name: '企业管理',
        component: companyBusiness,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/mark/markList',
        name: '商标管理',
        component: markList,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/soft/softList',
        name: '软著管理',
        component: softList,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/pat/patList',
        name: '专利管理',
        component: patList,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/console/consoleAgency',
        name: '控制台',
        component: consoleAgency,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/console/consolePark',
        name: '控制台',
        component: consolePark,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/console/consoleBusiness',
        name: '控制台',
        component: consoleBusiness,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/console/consoleCollege',
        name: '控制台',
        component: consoleCollege,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },  
      {
        path: '/console/consoleSuper',
        name: '控制台',
        component: consoleSuper,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/technology',
        name: '专利管理',
        component: systemTechnology,
        iconCls: 'el-icon-tickets',
        meta: {
          requireAuth: true
        }
      },
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js